/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `ADMINISTRATOR` - Administrator
 *   * `VLASTNIK` - Vlastnik
 *   * `SPRAVCE` - Spravce
 *   * `PROVOZOVATEL` - Provozovatel
 *   * `VYJADROVATEL` - Vyjadrovatel
 *   * `EDITOR` - Editor
 * ```
 */
export const TypySubjektuEnum = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  VLASTNIK: 'VLASTNIK',
  SPRAVCE: 'SPRAVCE',
  PROVOZOVATEL: 'PROVOZOVATEL',
  VYJADROVATEL: 'VYJADROVATEL',
  EDITOR: 'EDITOR',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TypySubjektuEnum = ValuesOf<typeof TypySubjektuEnum>;

export type TypySubjektuEnumRequest = TypySubjektuEnum;
export type TypySubjektuEnumResponse = TypySubjektuEnum;
